import React, { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import { fetchMediaBlobUrl } from "../utils/mediaUrl";

function AuthAvatar({ src, alt = "", children, sx, ...props }) {
  const [blobUrl, setBlobUrl] = useState("");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;

    (async () => {
      setFailed(false);
      if (!src) {
        setBlobUrl("");
        return;
      }
      try {
        const url = await fetchMediaBlobUrl(src);
        if (active) setBlobUrl(url);
      } catch {
        if (active) {
          setBlobUrl("");
          setFailed(true);
        }
      }
    })();

    return () => {
      active = false;
    };
  }, [src]);

  const showImage = Boolean(blobUrl) && !failed;

  return (
    <Avatar src={showImage ? blobUrl : undefined} alt={alt} sx={sx} {...props}>
      {!showImage ? children : null}
    </Avatar>
  );
}

export default AuthAvatar;
